import format from 'date-fns/format';
import React from 'react';
import { Outlet, useParams } from 'react-router-dom';

import { useEntityByIdSuspenseQuery } from '@eluve/apollo-client';
import { Heading, Link, Stack } from '@eluve/components';
import { graphql } from '@eluve/graphql.tada';

import {
  AppointmentOutputsTabNav,
  outputTypesFragment,
} from './AppointmentOutputsTabNav';

const appointmentDetailsQuery = graphql(
  `
    query appointmentDetails($tenantId: uuid!, $appointmentId: uuid!) {
      appointmentsByPk(tenantId: $tenantId, id: $appointmentId) {
        __typename
        id
        name
        startDate
        transcripts {
          transcript
        }
      }
      ...outputTypes
    }
  `,
  [outputTypesFragment],
);

export interface AppointmentDetailsPageProps {}

export const AppointmentDetailsPage: React.FC<
  AppointmentDetailsPageProps
> = () => {
  const { tenantId, appointmentId } = useParams() as {
    tenantId: string;
    appointmentId: string;
  };

  const { appointmentsByPk: appointment } = useEntityByIdSuspenseQuery(
    appointmentDetailsQuery,
    { tenantId, appointmentId },
    { entityKey: 'appointmentsByPk', entityType: 'Appointment' },
  );

  return (
    <Stack
      className="h-screen bg-bg-primary"
      direction="horizontal"
      align="stretch"
    >
      <div className="w-full p-2 md:p-4">
        <div className="mt-2 grid gap-1 border-b border-border-tertiary md:mt-4">
          <Heading size="2xl" weight="semibold">
            {format(new Date(appointment.startDate), 'cccc, MMMM do')}
          </Heading>
          <Link to={`/organizations/${tenantId}/appointments/${appointmentId}`}>
            <Heading size="3xl">{appointment.name}</Heading>
          </Link>
        </div>
        <AppointmentOutputsTabNav appointmentId={appointmentId} />
        <div className="mt-2 w-full">
          <Outlet />
        </div>
        <Stack
          className="mt-8 px-8 py-2"
          direction="horizontal"
          gap={16}
          align="stretch"
        ></Stack>
      </div>
    </Stack>
  );
};
